import React from 'react';
import {
  reduxForm,
  Field,
  FieldArray,
  change,
  getFormValues,
} from 'redux-form';
import LabelSection from 'components/sections/LabelSection';
import { connect } from 'react-redux';
import {
  onClickCancel,
  showModalItemPurchase,
  onChangeOutletForm,
} from 'actions/inventory/purchaseOrder';
import withFeatureFlags from 'hocs/withFeatureFlags';
import { rupiah, useMokaOutletPropsFirst } from 'utils/formatter';
import { error } from 'actions/notifications';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import SettingField from 'components/Fields/ReduxForm/SettingField';
import {
  NAMESPACE_INGREDIENTS,
  NAMESPACE_ITEMS,
} from 'actions/inventory/constants';
import { Link } from 'react-router';
import styles from './FormPurchaseOrder.css';

const validate = (values, props) => {
  const errors = {};
  const itemPurchaseErrors = [];
  const maxOrder =
    props.namespace === NAMESPACE_ITEMS ? 999999999 : 999999999.99;
  if (values.itemPurchase) {
    values.itemPurchase.forEach((member, index) => {
      const order = `${member.order}`;
      const unitcost = `${member.unitcost}`;
      const memberErrors = {};
      if (!member.order) {
        if (`${member.order}` !== '0') {
          memberErrors.order = 'Please enter a value';
          itemPurchaseErrors[index] = memberErrors;
        } else {
          if (order.match(/^0\d/)) {
            memberErrors.order = 'Please enter a valid Number';
            itemPurchaseErrors[index] = memberErrors;
          }
          if (parseInt(member.order) > maxOrder) {
            memberErrors.order = `Order must be less than ${maxOrder}`;
            itemPurchaseErrors[index] = memberErrors;
          }
        }
      }
      if (!member.unitcost) {
        if (`${member.unitcost}` !== '0') {
          memberErrors.unitcost = 'Please enter a value';
          itemPurchaseErrors[index] = memberErrors;
        }
      } else {
        if (unitcost.match(/^0\d/)) {
          memberErrors.unitcost = 'Please enter a valid Number';
          itemPurchaseErrors[index] = memberErrors;
        }
        if (parseInt(member.unitcost) > 99999999999) {
          memberErrors.unitcost = 'Unit cost must be less than 99.999.999.999';
          itemPurchaseErrors[index] = memberErrors;
        }
      }
    });
  }
  if (itemPurchaseErrors.length) {
    errors.itemPurchase = itemPurchaseErrors;
  }
  return errors;
};

const popoverFocus = ({ content }) => (
  <Popover id="purchaseOrder">{content}</Popover>
);

const normalizeNumber = (value = '0') => {
  if (typeof value === 'string') {
    return value.replace(/[^\d]/g, '');
  }
  return value;
};

const HeaderField = (member, index, fields) => {
  const isOneItem = fields.get(index).is_item;
  return (
    <div className={`row mk-grouped-input mb-10px`}>
      <div className={`col-sm-3 text-center ${styles['header-item']}`}>
        {isOneItem ? 'ITEM' : 'VARIANT'}
      </div>
      <div className={`col-sm-2 text-center ${styles['header-item']}`}>
        IN STOCK
      </div>
      <div className={`col-sm-2 text-center ${styles['header-item']}`}>
        ORDER
      </div>
      <div className={`col-sm-2 text-center ${styles['header-item']}`}>
        UNIT COST
      </div>
      <div className={`col-sm-3 text-center`}>TOTAL</div>
    </div>
  );
};

const HeaderTable = (member, index, fields) => {
  const itemName = fields.get(index).item_name;
  return (
    <div className={`form-group col-sm-12 mb-0px`}>
      <input
        value={itemName}
        readOnly
        className={`input-border-right item-name text-center form-control`}
      />
      <span
        className={`btn-addon trans-1 ${styles['remove-item']}`}
        onClick={() => {
          // use counter because when remove index, fields immediately shifts up
          let i = 0;
          fields.getAll().forEach((tmp, idx) => {
            if (tmp.item_id === fields.get(index).item_id) {
              fields.remove(idx - i);
              i++;
            }
          });
        }}
      >
        <i className="fa fa-times-circle" />
      </span>
    </div>
  );
};

const nameField = props => {
  const { input, isItem, isLast } = props;
  if (isItem) {
    return (
      <OverlayTrigger
        placement="top"
        trigger="hover"
        overlay={popoverFocus({ content: input.value })}
      >
        <input
          {...input}
          defaultValue={input.value}
          readOnly
          className={`${styles.itemDetailLeft} form-control`}
        />
      </OverlayTrigger>
    );
  }
  if (isLast) {
    return (
      <OverlayTrigger
        placement="top"
        trigger="hover"
        overlay={popoverFocus({ content: input.value })}
      >
        <input
          {...input}
          defaultValue={input.value}
          readOnly
          className={`${styles.itemDetailLeftDown} form-control`}
        />
      </OverlayTrigger>
    );
  }
  return (
    <OverlayTrigger
      placement="top"
      trigger="hover"
      overlay={popoverFocus({ content: input.value })}
    >
      <input
        {...input}
        defaultValue={input.value}
        readOnly
        className={`${styles.itemDetail} form-control`}
      />
    </OverlayTrigger>
  );
};

const stockField = props => {
  const { input } = props;
  return (
    <input
      {...input}
      placeholder={input.value}
      readOnly
      className={`${styles.itemStock} form-control`}
    />
  );
};

const totalField = props => {
  const { input, classNameField } = props;
  return (
    <input
      {...input}
      readOnly
      placeholder="Total"
      className={`${classNameField} form-control`}
    />
  );
};

class Form extends React.Component {
  constructor(props) {
    super(props);
    this.state = { openErrorAlert: false, errorItemName: null };
  }

  _dismissError = () => {
    this.setState({ openErrorAlert: false, errorItemName: null });
  };

  render() {
    const {
      suppliers,
      outlets,
      selected_outlet: selectedOutlet,
      handleSubmit,
      purchaseOrderDetail,
      search,
      allowDisableCreateAndFulfilledButton,
      disabledCreateAndFulfillButton,
    } = this.props;
    let namespace = 'item';
    if (search) {
      namespace = search.namespace;
    }
    const maxQty = namespace === NAMESPACE_ITEMS ? 999999999 : 999999999.99;
    const isEdit = purchaseOrderDetail !== null;
    const isDisabledCreateAndFulfilledButton =
      allowDisableCreateAndFulfilledButton && disabledCreateAndFulfillButton;
    // TODO harusnya supplierid insteadof supplier name
    return (
      <form className={styles.wrapper}>
        <div
          className={`${styles['field-wrapper']} purchase-order-field-wrapper`}
        >
          <div className="row">
            {!isEdit && (
              <div className="col-sm-12 form-group">
                <LabelSection title="choose outlet" />
                <Field
                  component="select"
                  name="outlet"
                  onChange={this._onChangeOutletId}
                  className="form-control"
                  disabled={selectedOutlet.length === 1 || isEdit}
                >
                  {outlets.map(o => {
                    return (
                      <option value={o.id} key={o.id}>
                        {useMokaOutletPropsFirst(o, outlet => outlet.name)}
                      </option>
                    );
                  })}
                </Field>
              </div>
            )}
            <div className="col-sm-12 form-group">
              <LabelSection title="choose supplier" />
              <Field
                component="select"
                name="supplierName"
                className="form-control"
                disabled={isEdit}
              >
                {suppliers.map(s => {
                  return (
                    <option value={s.id} key={s.id}>
                      {s.name}
                    </option>
                  );
                })}
              </Field>
            </div>
            <div className="col-sm-12 form-group">
              <LabelSection title="note" />
              <Field
                component="textarea"
                name="note"
                className="form-control"
                placeholder="Notes"
                rows="5"
              />
            </div>
            <div className="col-sm-12 form-group">
              <LabelSection title="Purchase Order" />
              <div className={styles['warning-style']}>
                {this.state.openErrorAlert && (
                  <div className="alert alert-danger">
                    <span
                      onClick={this._dismissError}
                      className={`glyphicon glyphicon-remove ${
                        styles['dismiss-warning-button']
                      }`}
                      aria-hidden="true"
                    />
                    <h5 className={`ml-30px`}>
                      Maximum {this.state.errorItemName} in stock {maxQty}
                    </h5>
                  </div>
                )}
              </div>
              <FieldArray
                name="itemPurchase"
                component={this._renderItemPurchase}
              />
              <button
                className={`btn btn-primary mt-20px ${styles['btn-addItems']}`}
                onClick={this._onClickAddItems}
              >
                {namespace === NAMESPACE_INGREDIENTS
                  ? 'Add Ingredients'
                  : 'Add Items'}
              </button>
              <div className={styles['label-track-item']}>
                <i
                  className={`fa fa-exclamation-circle ${styles['info-icon']}`}
                />
                {namespace === NAMESPACE_INGREDIENTS ? (
                  <label>
                    Make sure the ingredients have been tracked on{' '}
                    <Link
                      to="/ingredient/list"
                      className={styles['link-library']}
                    >
                      Ingredient
                    </Link>{' '}
                    page!
                  </label>
                ) : (
                  <label>
                    Make sure the items have been tracked on{' '}
                    <Link to="/library/list" className={styles['link-library']}>
                      Library
                    </Link>{' '}
                    page!
                  </label>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.footer}>
          <span className="pull-right">
            <button
              className={`btn btn-default ${styles['btn-cancel']}`}
              type="button"
              onClick={this._onClickCancel}
            >
              Cancel
            </button>
            {!purchaseOrderDetail && (
              <button
                className={`btn btn-primary ${styles['btn-save']}`}
                disabled={isDisabledCreateAndFulfilledButton}
                onClick={handleSubmit(this._onClickCreateAndFulfill)}
              >
                Create and Fulfill
              </button>
            )}
            {!purchaseOrderDetail && (
              <button
                className={`btn btn-primary ${styles['btn-save']}`}
                disabled={isDisabledCreateAndFulfilledButton}
                onClick={handleSubmit(this._onClickCreate)}
              >
                Create
              </button>
            )}
            {purchaseOrderDetail && (
              <button
                disabled={isDisabledCreateAndFulfilledButton}
                className={`btn btn-primary ${styles['btn-save']}`}
                onClick={handleSubmit(this._onClickSave)}
              >
                Save
              </button>
            )}
          </span>
        </div>
      </form>
    );
  }

  _onClickCancel = e => {
    this.props.dispatch(onClickCancel());
    e.preventDefault();
    e.stopPropagation();
  };

  _onClickAddItems = e => {
    const { dispatch } = this.props;
    dispatch(showModalItemPurchase());
    e.preventDefault();
    e.stopPropagation();
  };

  _onClickCreateAndFulfill = values => {
    const { dispatch, search } = this.props;
    let notZero = false;
    values.itemPurchase.forEach(item => {
      // Front End must process the order and unitcost using parsefloat or parseint since the backend return the value as a string
      if (
        (search.namespace === NAMESPACE_INGREDIENTS
          ? parseFloat(item.order)
          : parseInt(item.order)) > 0
      ) {
        notZero = true;
      }
    });
    if (values.itemPurchase.length > 0) {
      if (notZero) {
        this.props.onSubmit({ ...values, action: 'createFulfilled' });
      } else {
        dispatch(error('Total order must be greater than 0'));
      }
    } else if (search.namespace !== NAMESPACE_INGREDIENTS) {
      dispatch(error('Please add purchase item before saving'));
    } else {
      dispatch(error('Please add purchase ingredient before saving'));
    }
  };

  _onChangeOutletId = () => {
    const { dispatch } = this.props;
    dispatch(onChangeOutletForm());
  };

  _onClickCreate = values => {
    const { dispatch, onSubmit, search } = this.props;
    let notZero = false;
    values.itemPurchase.forEach(item => {
      // Front End must process the order and unitcost using parsefloat or parseint since the backend return the value as a string
      if (
        (search.namespace === NAMESPACE_INGREDIENTS
          ? parseFloat(item.order)
          : parseInt(item.order)) > 0
      ) {
        notZero = true;
      }
    });

    if (values.itemPurchase.length > 0) {
      if (notZero) {
        onSubmit({ ...values, action: 'create' });
      } else {
        dispatch(error('Total order must be greater than 0'));
      }
    } else if (search.namespace !== NAMESPACE_INGREDIENTS) {
      dispatch(error('Please add purchase item before saving'));
    } else {
      dispatch(error('Please add purchase ingredient before saving'));
    }
  };

  _onClickSave = values => {
    const { dispatch, onSubmit, search } = this.props;
    let notZero = false;
    values.itemPurchase.forEach(item => {
      // Front End must process the order and unitcost using parsefloat or parseint since the backend return the value as a string
      if (
        (search.namespace === NAMESPACE_INGREDIENTS
          ? parseFloat(item.order)
          : parseInt(item.order)) > 0
      ) {
        notZero = true;
      }
    });
    if (notZero) {
      if (values.itemPurchase.length > 0) {
        onSubmit({ ...values, action: 'saved' });
      } else if (search.namespace !== NAMESPACE_INGREDIENTS) {
        dispatch(error('Please add purchase item before saving'));
      } else {
        dispatch(error('Please add purchase ingredient before saving'));
      }
    } else {
      dispatch(error('Total order must be greater than 0'));
    }
  };

  _renderItemPurchase = ({ fields }) => {
    let total = 0;
    let itemId = 0;
    return (
      <div>
        {fields.map((...props) => {
          const [, index] = props;
          const field = fields.get(index);
          const qty = !field.order ? 0 : field.order;
          const price = !field.unitcost ? 0 : field.unitcost;
          const subTotal = normalizeNumber(qty * price);
          const shouldRenderHeader = itemId === 0 || itemId !== field.item_id;
          const isItem = field.is_item;
          itemId = field.item_id;
          total += parseFloat(subTotal);
          return (
            <div key={index}>
              {shouldRenderHeader && (
                <div className={`row mk-grouped-list-input`}>
                  {HeaderField(...props)}
                </div>
              )}
              <div className={`row mk-grouped-list-input`}>
                {shouldRenderHeader && !isItem && HeaderTable(...props)}
                {this._itemPurchase(...props)}
              </div>
            </div>
          );
        })}
        <div className="pull-left mt-30px">TOTAL</div>
        <div className="pull-right mt-30px">{rupiah(Math.round(total))}</div>
      </div>
    );
  };

  _itemPurchase = (member, index, fields) => {
    const {
      search: { namespace },
    } = this.props;
    const isItem = fields.get(index).is_item;
    const isLast = !fields.get(index + 1)
      ? true
      : fields.get(index + 1).item_id !== fields.get(index).item_id;
    const { order, unitcost } = fields.get(index);
    let total = unitcost * order;
    if (isNaN(total)) {
      total = 0;
    }
    return (
      <div className={`mk-grouped-input grouped-form`}>
        <div
          className={`form-group col-md-3 ${isLast ? styles['mb-25px'] : ''}`}
        >
          {isItem && (
            <Field
              component={nameField}
              name={`${member}.item_name`}
              type="text"
              isItem={isItem}
              isLast={isLast}
            />
          )}
          {!isItem && (
            <Field
              component={nameField}
              name={`${member}.item_var_name`}
              type="text"
              isItem={isItem}
              isLast={isLast}
            />
          )}
        </div>
        <div className="form-group col-md-2">
          <Field
            component={stockField}
            name={`${member}.instock`}
            type="text"
          />
        </div>
        <div className="form-group col-md-2">
          <Field
            component={SettingField}
            name={`${member}.order`}
            className="form-control"
            inputClassName={styles['input-field-30px']}
            placeholder="Order"
            normalize={this._normalizeOrder(index)}
            onChange={(event, value) => {
              if (namespace === NAMESPACE_INGREDIENTS) {
                total = parseFloat(value) * parseInt(unitcost);
              } else {
                total = parseInt(value) * parseInt(unitcost);
              }
              total = !isNaN(total) ? total : 0;
              this.props.dispatch(
                change('purchaseOrder', `${member}.total`, rupiah(total))
              );
              return value;
            }}
            positiveNumberOnly
            maxFractionDigits={namespace === NAMESPACE_INGREDIENTS ? 2 : 0}
          />
        </div>
        <div className="form-group col-md-2">
          <Field
            component={SettingField}
            name={`${member}.unitcost`}
            className="form-control"
            placeholder="Unit Cost"
            positiveNumberOnly
            inputClassName={styles['input-field-30px']}
            onChange={(event, value) => {
              if (namespace === NAMESPACE_INGREDIENTS) {
                total = parseInt(value) * parseFloat(order);
              } else {
                total = parseInt(value) * parseInt(order);
              }
              total = !isNaN(total) ? total : 0;
              this.props.dispatch(
                change('purchaseOrder', `${member}.total`, rupiah(total))
              );
              return value;
            }}
          />
        </div>
        <div className="form-group col-md-3">
          {isItem && (
            <Field
              component={totalField}
              name={`${member}.total`}
              classNameField={styles.itemDetailRight}
              type="text"
            />
          )}
          {!isItem && isLast && (
            <Field
              component={totalField}
              name={`${member}.total`}
              classNameField={styles.itemDetailRightDown}
              type="text"
            />
          )}
          {!isLast && !isItem && (
            <Field
              component={totalField}
              name={`${member}.total`}
              classNameField={styles.itemDetail}
              type="text"
            />
          )}
          {isItem && (
            <span
              className="btn-addon trans-1"
              onClick={() => fields.remove(index)}
            >
              <i className="fa fa-times-circle" />
            </span>
          )}
        </div>
      </div>
    );
  };

  _normalizeOrder = index => (value, previousValue, allValues) => {
    const {
      search: { namespace },
    } = this.props;
    if (value === '') {
      return value;
    }
    const maxValue =
      namespace === NAMESPACE_INGREDIENTS ? 999999999.99 : 999999999;
    if (!isNaN(value)) {
      if (
        parseInt(value) + parseInt(allValues.itemPurchase[index].instock) <=
        maxValue
      ) {
        return value;
      }
      this._onErrorOrder(
        namespace === NAMESPACE_INGREDIENTS
          ? allValues.itemPurchase[index].item_name
          : !allValues.itemPurchase[index].item_var_name
          ? allValues.itemPurchase[index].item_name
          : allValues.itemPurchase[index].item_var_name
      );
      const maxQty = maxValue - allValues.itemPurchase[index].instock;
      return namespace === NAMESPACE_INGREDIENTS
        ? (maxQty - parseInt(maxQty)).toString().length > 4
          ? maxQty.toFixed(2)
          : maxQty
        : parseInt(maxQty);
    }
    return previousValue;
  };

  _onErrorOrder = item => {
    this.setState({ openErrorAlert: true, errorItemName: item });
    setTimeout(
      function() {
        this.setState({ openErrorAlert: false });
      }.bind(this),
      1000
    );
  };
}

const mapForm = {
  form: 'purchaseOrder',
  touchOnBlur: true,
  touchOnChange: true,
  validate,
};

function mapStateToProps(state) {
  const {
    suppliers,
    outlets,
    selected_outlet,
    purchaseOrderDetail,
    disabledCreateAndFulfillButton,
  } = state.inventory.purchaseOrder;
  return {
    suppliers,
    outlets,
    selected_outlet,
    purchaseOrderDetail,
    disabledCreateAndFulfillButton,
    POForm: getFormValues('purchaseOrder')(state),
    search: getFormValues('search')(state),
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

const connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm(mapForm)(Form));

Form.defaultProps = {
  allowDisableCreateAndFulfilledButton: false,
};

const mapFlagsToProps = flags => ({
  allowDisableCreateAndFulfilledButton: flags.disabledCreateAndFulfilledButton,
});

export default withFeatureFlags(mapFlagsToProps)(connected);
